import {
  MenuItem,
  MenuItemProps,
} from '@/components/poppers/MenuPopper/MenuItem';

import { useDuplicateProposal } from '../../hooks/useDuplicateProposal';
import { ProposalKind } from '../../types/ProposalKind';

export interface DuplicateProposalMenuItemProps {
  proposalId: string;
  kind: ProposalKind;
  afterDuplicate: (createdProposalId: string) => void;
  menuItemProps?: Partial<MenuItemProps>;
}

export function DuplicateProposalMenuItem({
  proposalId,
  kind,
  afterDuplicate,
  menuItemProps,
}: DuplicateProposalMenuItemProps) {
  const [onDuplicateProposal, { loading: isDuplicatingProposal }] =
    useDuplicateProposal(proposalId);

  const showProposal = [ProposalKind.Entity].includes(kind);

  return (
    <MenuItem
      label={`Duplicate ${showProposal ? 'proposal' : 'analysis'}`}
      onClick={async () => {
        await onDuplicateProposal(afterDuplicate);
      }}
      disabled={isDuplicatingProposal}
      muiMenuItemProps={{
        divider: true,
        ...menuItemProps,
      }}
    />
  );
}
